





















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class BmnIntroductionModal extends Vue {
  @Prop()
  public communities: number;
  @Prop()
  public companies: number;

  public numberOfCommunities = this.communities;
  public numberOfCompanies = this.companies;

  public ready = false;

  public dismiss(event?: MouseEvent) {
    if (event && (event.target as Element).classList[0] !== 'modal-screen') {
      return;
    }
    this.ready = false;
    setTimeout(() => {
      this.$emit('dismiss');
    }, 900);
  }

  public mounted() {
    setTimeout(() => {
      this.ready = true;
    }, 250);
  }

}
